<template>
  <div>
    <div>
    <div class="top">
      <img
        class="avatar"
        alt=""
        :src="
          userInfo.headUrl
            ? userInfo.headUrl
            : require('../../assets/avatar.png')
        "
      />
      <div>
        <div class="row">
          <div class="phone">{{ userInfo.phone }}</div>
          <div v-if="userInfo.roleType == 1" class="agent">
            <img
              src="../../assets/agent_text.png"
              width="50px"
              style="margin-left: 5px"
            />
            <img :src="agentPic" width="20px" />
          </div>
        </div>

        <div class="phone">ID:{{ userInfo.virtuallyId }}</div>
      </div>

      <div class="logout" @click="logout">退出登录</div>
    </div>
    <div class="time">升级代理商时间：{{ userInfo.roleUpDate }}</div>
    <div class="level1Tip" v-if="userInfo.levelNum==1">自升级起30天内邀请注册人数未达到100人 自动降级</div>
  </div>
    <!-- 路由视图 -->
    <keep-alive>
      <router-view />
    </keep-alive>

    <van-tabbar v-model="active" route>
      <van-tabbar-item replace :to="{ name: 'income' }" icon="wap-home-o"
        >首页</van-tabbar-item
      >
      <van-tabbar-item replace :to="{ name: 'team' }" icon="friends-o"
        >团队</van-tabbar-item
      >
      <van-tabbar-item replace :to="{ name: 'charge' }" icon="after-sale"
        >充值记录</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
const v1 = require("../../assets/agent_v1.png");
const v2 = require("../../assets/agent_v2.png");
const v3 = require("../../assets/agent_v3.png");
const v4 = require("../../assets/agent_v4.png");

export default {
  data() {
    return {
      active: 0, // 设置默认选中的 Tab 索引
      userInfo: {},
      agentPic: "",
    };
  },

  //初始化页面选中状态
  created() {
    //由于 vant 标签栏路由模式，无法自动加载页面，所以这里需要初始化
    // console.log(this.$route); //打印当前路由属性
    if (this.$route.path === "/home") {
      this.$router.push({ name: "income" });
    }

    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$request.GET({
        url: "info",
        success: (obj) => {
          this.userInfo = obj;
          this.$store.commit("setUserInfo", obj);
          if (this.userInfo.levelNum == 1) {
            this.agentPic = v1;
          } else if (this.userInfo.levelNum == 2) {
            this.agentPic = v2;
          } else if (this.userInfo.levelNum == 3) {
            this.agentPic = v3;
          } else if(this.userInfo.levelNum == 4){
            this.agentPic = v4;
          }
        },
      });
    },

    logout() {
      Dialog.confirm({
        title: "提示",
        message: "确认退出登录？",
      })
        .then(() => {
          this.$store.commit("clear");
          localStorage.removeItem("appId");
          localStorage.removeItem("token");
          this.$router.push({ name: "login" });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style scoped lang="less">
@import url("vant/lib/index.less");

.time{
  font-size: 14px;
  text-align: left;
  margin-left: 20px;
  color: red;
}
.level1Tip{
  font-size: 12px;
  text-align: left;
  margin-left: 20px;
  color: red;
}
.top {
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .agent {
    width: 80px;
    height: 25px;
    background-image: url(../../assets/agent_bg.png);
    background-repeat: no-repeat;
    background-size: contain;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .avatar {
    margin-left: 20px;
    width: 45px;
    height: 45px;
    border-radius: 58%;
  }
  .phone {
    margin-left: 10px;
    text-align: left;
    font-size: 14px;
  }
  .logout {
    position: absolute;
    background-color: white;
    border-radius: 5px;
    border: 1px solid gray;
    width: 80px;
    height: 28px;
    text-align: center;
    font-size: 12px;
    color: black;
    line-height: 28px;
    margin-top: 10px;
    right: 20px;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>